var cache = {};

export default (type) => {
  return new Promise((resolve, reject) => {
    if(cache[type] != null) {
      resolve(cache[type]);
      return;
    }

    $.ajax({
      type: "GET",
      url: "/backgrounds_pixabay",
      data: {
        type: type,
      }
    }).then((data) => {
      cache[type] = data.data;
      resolve(data.data)
    }).catch(() => {
      reject()
    });
  });
}
